export * from './shipping-load-detail.component';
